import NewsletterFifteenContainer from "./containers/NewsletterFifteenContainer";
export default NewsletterFifteenContainer;
